import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { ErrorRedirectionService } from '../error-service/error-redirection.service';
import { UserService } from '../user.service';
import { Constants } from '@models/constants';
import { EmailService } from '@services/email/email.service';
@Injectable({
  providedIn: 'root',
})
export class AddPolicyDataService {
  /* Information
      This observable is only for the add policy process.
      Either in create account or link-policy.
      Please do not use this observable in any other spot.
  */
  newPolicy: any = {};
  private messageSource = new BehaviorSubject<any>(this.newPolicy);
  $newPolicy = this.messageSource.asObservable();
  email = '';
  private emailDoesNotMatch = new BehaviorSubject<boolean>(false);
  $emailDoesNotMatch = this.emailDoesNotMatch.asObservable();

  constructor(
    private router: Router,
    private errorRedirectionService: ErrorRedirectionService,
    private userService: UserService,
    private emailService: EmailService
  ) {}

  updateAddPolicy(policy: any) {
    this.messageSource.next(policy);
  }

  clearUser() {
    this.messageSource.next(null);
  }

  addPolicyErrorHandler(err, policyNumber) {
    if (
      this.router.url === '/my-insurance/edit-policy-details' ||
      this.router.url === '/my-insurance/link-policy' ||
      this.router.url === '/my-insurance/add-policy'
    ) {
      if (err.status === 409 || err.status === 500 || err.status === 400) {
        // Conflict, Policy is not found and name validation fails
        if (this.router.url === '/my-insurance/edit-policy-details') {
          this.router.navigate([Constants.MY_INSURANCE, 'policy-not-found']);
        } else {
          this.router.navigate([Constants.MY_INSURANCE, 'error-not-found']);
        }
      } else if (err.status === 404) {
        // 404 - if the policy belongs to another account
        this.email = err.error.Message || '';
        if (
          this.router.url === '/my-insurance/link-policy' ||
          this.router.url === '/my-insurance/add-policy'
        ) {
          this.router.navigate([Constants.MY_INSURANCE, 'account-exists']);
        } else {
          this.router.navigate([Constants.MY_INSURANCE, 'policy-belongs-to-another'], {
            queryParams: { id: policyNumber },
          });
        }
      } else {
        this.errorRedirectionService.redirect(err.status);
      }
    } else {
      if (err.status === 409 || err.status === 500 || err.status === 400) {
        // Conflict, Policy is not found and name validation fails
        const isCommercialAc = this.userService.getCommercialAcFlag();
        if (isCommercialAc) {
          this.router.navigate(['signup', 'not-found-ca']);
        } else {
          this.router.navigate(['signup', 'not-found']);
        }
      } else if (err.status === 404) {
        // 404 - if the policy belongs to another account
        this.router.navigate(['signup', 'policy-belongs-to-another']);
      } else {
        this.errorRedirectionService.redirect(err.status);
      }
    }
  }

  maskEmail() {
    if (this.email.includes('@')) {
      return this.emailService.maskEmail(this.email);
    } else {
      return '';
    }
  }
}
